import React, { useState } from 'react';
import { Card, CardContent, Grid, TextField, Typography, makeStyles } from '@material-ui/core';
import { Button } from '@mui/material';
import Theme from '../ui/Theme';
import { ErrorToast } from '../utils/Utils';

const useStyles = makeStyles(() => ({
  mainDiv: {
    marginBottom: '10px',
    backgroundColor: Theme.palette.secondary.main,
    // backgroundColor: "white",
    maxHeight: '68%',
    height: '68%',
    overflowY: 'auto',
    overflowX: 'hidden',
    '&::-webkit-scrollbar': { width: '10px' },
    '&::-webkit-scrollbar-track': {
      boxShadow: 'inset 0 0 5px grey',
      borderRadius: '20px',
    },
    '&::-webkit-scrollbar-thumb': {
      background: 'lightGrey',
      borderRadius: '100px',
    },
  },
  searchText: {
    width: '98%',
    height: '42px',
    background: '#FAFAFA',
    border: '1px solid #E2E2E2',
    padding: '8px',
    fontFamily: 'Montserrat',
    fontWeight: '500',
    fontSize: '14px',
    borderRadius: '8px',
    margin: '10px',
  },
  cardContent: {
    borderRadius: '8px',
    margin: '5px',
    height: '58px',
    cursor: 'pointer',
  },
  collectionName: {
    fontSize: '14px',
    fontWeight: 600,
    fontStyle: 'normal',
    color: '#10182B',
  },
  secondaryText: {
    fontSize: '12px',
    fontWeight: 500,
    fontStyle: 'normal',
    color: '#667085',
  },
  selectedTab: {
    borderBottom: '2px solid #632eee !important',
    height: '40px',
    color: 'black !important',
    borderRadius: '0px !important',
  },
  unselectedTab: {
    borderBottom: '2px transparent !important',
    height: '40px',
    color: 'black !important',
    borderRadius: '0px !important',
  },
}));

export default function CollectionList({
  handleSearchCollection,
  searchCollectionValue,
  filteredCollectionList,
  handleCollectionClicked,
  topicSelectedId,
  collectionTabs,
  setCollectionList,
}) {
  const classes = useStyles();
  const [selectedTab, setSelectedTab] = useState('All Departments');
  const handleClick = (title) => {
    setSelectedTab(title);
    setCollectionList(collectionTabs[title]);
  };
  return (
    <div className={classes.mainDiv}>
      <Grid style={{ paddingLeft: '20px', margin: '0px 10px', background: '#fefefe' }}>
        {Object.keys(collectionTabs)?.map((data) => (
          <Button
            key={data}
            onClick={() => handleClick(data)}
            className={selectedTab === data ? classes.selectedTab : classes.unselectedTab}
          >
            {data}
          </Button>
        ))}
      </Grid>
      <TextField
        id="searchId"
        name="search"
        required
        autoComplete="off"
        autoSave="off"
        onChange={handleSearchCollection}
        placeholder="Search Topics"
        value={searchCollectionValue}
        InputProps={{
          disableUnderline: true,
          className: classes.searchText,
        }}
        rows={1}
      />
      <Grid container>
        {filteredCollectionList?.map((col) => (
          <Grid item xs={4} key={col.id}>
            <Card
              className={classes.cardContent}
              onClick={() => {
                if (col.disabled) {
                  ErrorToast(col.error || 'Topics should have checkin');
                } else {
                  handleCollectionClicked(col);
                }
              }}
              style={{
                ...(col.id === topicSelectedId
                  ? { border: '1px solid var(--brand-300, #BEB3FF)', background: 'var(--brand-50, #F4F3FF)' }
                  : {}),
              }}
            >
              <CardContent>
                <Typography
                  noWrap
                  className={classes.collectionName}
                  style={{ ...(col.disabled ? { color: 'grey' } : {}) }}
                >
                  {col.title}
                </Typography>
                <Typography noWrap className={classes.secondaryText}>
                  {`${col.journeyCount || 0} ${col.journeyCount === 1 ? 'journey' : 'journeys'}`}
                </Typography>
              </CardContent>
            </Card>
          </Grid>
        ))}
      </Grid>
    </div>
  );
}
